import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { getPrivateInstance } from "../_privateInstance";
import { parseStaffRegulator } from "./parseStaffRegulator";
import { staffRegulatorRevokePath } from "./staffRegulatorPaths";
import { STAFF_REGULATORS_LIST_QUERY_KEY } from "./useStaffRegulatorsList";
import type { StaffRegulator, StaffRegulatorEnvelope } from "./types";

export const postRevokeStaffRegulator = async (
  adminId: string,
): Promise<StaffRegulator | null> => {
  const response = await getPrivateInstance().post<
    StaffRegulatorEnvelope<unknown>
  >(staffRegulatorRevokePath(adminId), {});
  return parseStaffRegulator(response.data?.data);
};

export const useRevokeStaffRegulator = (): UseMutationResult<
  StaffRegulator | null,
  Error,
  string
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["staff-regulators", "revoke"],
    mutationFn: postRevokeStaffRegulator,
    onSuccess: (_data, adminId) => {
      queryClient.invalidateQueries({
        queryKey: ["staff-regulators", "detail", adminId],
      });
      queryClient.invalidateQueries({
        queryKey: STAFF_REGULATORS_LIST_QUERY_KEY,
      });
    },
  });
};
